import React, {useCallback} from 'react';

import {Skeleton} from 'src/components/skeleton';

import {CheckBox} from '@pb/kit-component-checkbox';
import FormSection from '@pb/kit-component-form-section';
import {Group} from '@pb/kit-component-group';

import {PitchBookSectionSkeleton} from './pitchbook-skeleton';

import type {Dispatch, SetStateAction} from 'react';
import type {PitchBookCrmSettings} from 'src/openapi/admin/models/PitchBookCrmSettings';
import type {CheckBoxChangeData} from 'src/typedef';

type Props = {
    isLoading: boolean,
    disabled?: boolean,
    settings: PitchBookCrmSettings,
    setSettings: Dispatch<SetStateAction<PitchBookCrmSettings>>,
};

export const PitchBookSection = ({isLoading, disabled, setSettings, settings}: Props) => {
    const onSettingsChange = useCallback(({event, name}: CheckBoxChangeData) => {
        setSettings(prevState => ({
            ...prevState,
            [name]: event.currentTarget.checked,
        }));
    }, [setSettings]);

    return (
        <Skeleton shown={isLoading} view={<PitchBookSectionSkeleton/>}>
            <FormSection headline="Notes & Files View Permissions">
                <Group direction="v" alignItems="start">
                    <CheckBox
                        name="accountPrivacyEnabled"
                        disabled={disabled}
                        label="Can post to entire account"
                        checked={settings.accountPrivacyEnabled}
                        onCheckBoxChange={onSettingsChange}
                    />
                    <CheckBox
                        name="groupPrivacyEnabled"
                        disabled={disabled}
                        label="Can post to My Group"
                        checked={settings.groupPrivacyEnabled}
                        onCheckBoxChange={onSettingsChange}
                    />
                    <CheckBox
                        name="userPrivacyEnabled"
                        disabled={disabled}
                        label="Can post to Only Me"
                        checked={settings.userPrivacyEnabled}
                        onCheckBoxChange={onSettingsChange}
                    />
                </Group>
            </FormSection>
        </Skeleton>
    );
};
